import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Events from './views/Events'
import Ticketsets from './views/Ticketsets'
import Login from './views/Login'
import Scanner from './views/Scanner'
import Settings from './views/Settings'
import Statistics from "@/views/Statistics.vue";

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/login/',
            name: 'login',
            component: Login
        },
        {
            path: '/events/',
            name: 'events',
            component: Events
        },
        {
            path: '/ticketsets/',
            name: 'ticketsets',
            component: Ticketsets
        },
        {
            path: '/scanner/',
            name: 'scanner',
            component: Scanner,
            props: { test: false }
        },
        {
            path: '/test-scanner/',
            name: 'test-scanner',
            component: Scanner,
            props: { test: true }
        },
        {
            path: '/settings/',
            name: 'settings',
            component: Settings
        },
        {
            path: '/statistics/',
            name: 'statistics',
            component: Statistics
        }
        // {
        //   path: '/about',
        //   name: 'about',
        //   // route level code-splitting
        //   // this generates a separate chunk (about.[hash].js) for this route
        //   // which is lazy-loaded when the route is visited.
        //   component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
        // }
    ]
})
